<template>
    <div id="flashContent" style="margin-left:20px;margin-top:20px;">
        <div v-if="videoPath">
            <object id="G12EHLSPlayer20" classid="clsid:d27cdb6e-ae6d-11cf-96b8-444553540000" align="middle" width="720"
                    height="420">
                <param name="movie" value="/styles/G12EHLSPlayer20.swf?v=1"/>
                <param name="bgcolor" value="#ffffff"/>
                <param name="wmode" value="transparent"/>
                <param name="allowScriptAccess" value="always"/>
                <param name="allowFullScreen" value="true"/>
                <param name="FlashVars" :value="videoPath"/>
                <embed id="G12EHLSPlayer20em" allowscriptaccess="always" wmode="transparent"
                       src="/styles/G12EHLSPlayer20.swf?v=1" allowFullScreen="true" type="application/x-shockwave-flash"
                       :flashvars="videoPath" width="720" height="420"/>
            </object>
        </div>
    </div>
</template>

<script>
  import { getRscVideo } from '@/api/player';
  import { $Cookies } from '@/utils';

  export default {
    name: 'audioPlayer',
    components: {},
    props: {
      rscId: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        videoPath: ''
      };
    },
    async created () {
      const uid = $Cookies.get('uid') || '0';
      await getRscVideo({
        rscID: this.rscId,
        userNo: Number(uid)
      }).then(data => {
        if (data.success) {
          const { startTime, endTime, url } = data.result;
          this.videoPath = 'videoPath=' + url + '&playRegion=' + startTime + '-' + endTime;
        } else {
          this.$message({
            type: 'error',
            message: data.errorMsg
          });
        }
      });
    },
    methods: {}
  };
</script>

<style lang="scss">
    #flashContent {
        width: 100%;
        height: 100%;
        margin: 0 !important;
    }
</style>
